"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
var Box_1 = __importDefault(require("./Box"));
var arrowShadow = function (props) {
    return props.top
        ? {
            'box-shadow': '-9.66px 9.66px 8px 0 rgba(0,0,0,0.04), -4px 4px 4px 0 rgba(0,0,0,0.08)'
        }
        : {
            'box-shadow': '-1.41px 1.41px 1px 0 rgba(0,0,0,0.01), -3.66px 3.66px 8px 0 rgba(0,0,0,0.04)'
        };
};
var arrowAlign = function (props) {
    if (props.left) {
        return { left: '16px', 'margin-left': props.top ? 0 : '15px' };
    }
    if (props.center) {
        return { left: '50%', 'margin-left': props.top ? '-7px' : '7px' };
    }
    return { right: '16px', 'margin-right': props.top ? '5px' : '-10px' };
};
var arrowPosition = function (props) {
    return props.top
        ? {
            'transform-origin': '0 0',
            transform: 'rotate(-45deg)',
            bottom: '-10px'
        }
        : {
            'transform-origin': '0 0',
            transform: 'rotate(-225deg)',
            top: '0'
        };
};
var arrow = function (props) {
    return props.top
        ? {
            'transform-origin': '0 0',
            transform: 'rotate(-45deg)'
        }
        : {
            'transform-origin': '0 0',
            transform: 'rotate(-225deg)'
        };
};
var tooltipPosition = function (props) {
    return props.top ? { bottom: '-8px' } : { top: 0 };
};
var tooltipAlign = function (props) {
    var right = props.right, center = props.center;
    if (right) {
        return { right: '-12px' };
    }
    if (center) {
        return { left: '50%', width: 'auto', transform: 'translateX(-50%)' };
    }
    return null;
};
var StyledSpan = styled_components_1["default"].span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  ", "\n"], ["\n  position: relative;\n\n  ", "\n"])), styled_system_1.zIndex);
var TooltipContent = styled_components_1["default"](Box_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline;\n  box-shadow: ", ";\n  position: absolute;\n  border-radius: ", "px;\n  box-sizing: border-box;\n  background: ", ";\n  text-align: left;\n  font-size: ", "px;\n\n  ", " {\n    font-size: ", "px;\n  }\n\n  ", "\n  ", "\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent ", "\n      ", ";\n\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n"], ["\n  display: inline;\n  box-shadow: ", ";\n  position: absolute;\n  border-radius: ", "px;\n  box-sizing: border-box;\n  background: ", ";\n  text-align: left;\n  font-size: ", "px;\n\n  ", " {\n    font-size: ", "px;\n  }\n\n  ", "\n  ", "\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent ", "\n      ", ";\n\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.boxShadows[1];
}, function (_a) {
    var theme = _a.theme;
    return theme.radii[1];
}, function (_a) {
    var theme = _a.theme, bg = _a.bg;
    return theme.colors[bg];
}, function (_a) {
    var theme = _a.theme;
    return theme.fontSizes[0];
}, styled_system_1.themeGet('mediaQueries.md'), function (_a) {
    var theme = _a.theme;
    return theme.fontSizes[1];
}, tooltipPosition, tooltipAlign, function (_a) {
    var theme = _a.theme, bg = _a.bg;
    return theme.colors[bg];
}, function (_a) {
    var bg = _a.bg, theme = _a.theme;
    return theme.colors[bg];
}, arrow, arrowPosition, arrowAlign, arrowShadow);
var Tooltip = function (_a) {
    var children = _a.children, zIndexProp = _a.zIndex, rest = __rest(_a, ["children", "zIndex"]);
    return (react_1["default"].createElement(StyledSpan, { zIndex: zIndexProp },
        react_1["default"].createElement(TooltipContent, __assign({ p: 3, mb: 3, mt: 2 }, rest), children)));
};
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
    bg: 'white',
    color: 'text',
    zIndex: 'auto'
};
exports["default"] = Tooltip;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tooltip.js.map